// extracted by mini-css-extract-plugin
export var wrapper = "bottom-module--wrapper--HUcaX";
export var nav = "bottom-module--nav--AR6lx";